/*
 * @Author: zyy
 * @Date: 2022-11-11 17:46:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 16:40:35
 * @Description: default
 */
export const TJListMixin = {
    data() {
        return {
            labelCol: { span: 3 },
            wrapperCol: { span: 18 },
            ipagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['2', '5', '10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            loading: false,
            searchQuery: {
                page: 1,
                per_page: 10
            },
            modal: {
                show: false,
                loading: false
            },
        }
    },
    mounted() {
        this.getList()
    },
    activated() {
        this.getList()
    },
    methods: {

        // 新分页
        handlePageChange(page) {
            this.ipagination.current = page.current;
            this.ipagination.pageSize = page.pageSize;

            this.searchQuery.page = page.current
            this.searchQuery.per_page = page.pageSize
            this.getList()
        },
        toSearch() {
            this.searchQuery.page = 1
            this.getList()
        },
        searchReset() {
            this.searchQuery = {
                page: 1,
                per_page: 10
            }
            this.getList()
        },
        getList() { }

    }

}

